var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null);

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Confirm-Email",
  transform: "translate(-683.000000, -416.000000)",
  stroke: "#58BCC4",
  strokeWidth: 6
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(494.000000, 419.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "mail",
  transform: "translate(192.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.79354839,0 L61.1419355,0 C64.8783871,0 67.9354839,3.0375 67.9354839,6.75 L67.9354839,47.25 C67.9354839,50.9625 64.8783871,54 61.1419355,54 L6.79354839,54 C3.05709677,54 0,50.9625 0,47.25 L0,6.75 C0,3.0375 3.05709677,0 6.79354839,0 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Shape",
  points: "67.9354839 6.96774194 33.9677419 30.483871 0 6.96774194"
})))));

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "60px",
    viewBox: "0 0 74 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mail") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.948d07c45a455a491b8ad1bc97e9b0db.svg";
export { ForwardRef as ReactComponent };